(function () {
  'use strict';
  if (window.biancelleHeroMotionReady || !('IntersectionObserver' in window)) return;
  window.biancelleHeroMotionReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');
  const heroes = new Map();
  let frame = null;
  const active = state => state.visible && !document.hidden && !reduced.matches;

  function schedule() {
    if (frame !== null || !desktop.matches || ![...heroes.values()].some(active)) return;
    frame = window.requestAnimationFrame(update);
  }
  function update() {
    frame = null;
    if (!desktop.matches || reduced.matches || document.hidden) return;
    const scroll = window.scrollY;
    const writes = [];
    // Geometry is cached until resize, re-entry, or an editor layout change.
    // Read all invalidated measurements before touching any transforms.
    heroes.forEach((state, hero) => {
      if (!active(state)) return;
      if (state.dirty) {
        state.top = hero.getBoundingClientRect().top + scroll;
        state.travel = Math.max(hero.offsetHeight - state.stage.offsetHeight, 1);
        state.dirty = false;
      }
      const progress = Math.min(1, Math.max(0, (scroll - state.top) / state.travel));
      const key = progress.toFixed(4);
      if (state.last === key) return;
      state.last = key;
      writes.push([state.bottle, 'translate3d(-50%, calc(-50% + ' + (progress * 16).toFixed(3) + 'rem), 0) rotate(' + (-5 + progress * 16).toFixed(3) + 'deg) scale(' + (1 + progress * .16).toFixed(4) + ')']);
    });
    writes.forEach(([bottle, transform]) => { bottle.style.transform = transform; });
  }
  function invalidate() {
    heroes.forEach(state => { state.dirty = true; });
    schedule();
  }
  function sync() {
    if (frame !== null) { window.cancelAnimationFrame(frame); frame = null; }
    heroes.forEach((state, hero) => {
      hero.classList.toggle('has-bottle-motion', !reduced.matches);
      hero.classList.toggle('bi-bottle-active', active(state));
      if (!desktop.matches || reduced.matches) {
        state.bottle.style.removeProperty('transform');
        state.last = null;
      }
      state.dirty = true;
    });
    schedule();
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = heroes.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting;
      state.dirty = true;
      entry.target.classList.toggle('bi-bottle-active', active(state));
    });
    if (![...heroes.values()].some(active) && frame !== null) {
      window.cancelAnimationFrame(frame); frame = null;
    }
    schedule();
  });
  const resize = 'ResizeObserver' in window ? new ResizeObserver(invalidate) : null;
  function initialize(root) {
    root.querySelectorAll('[data-bi-hero]').forEach(hero => {
      if (heroes.has(hero)) return;
      const bottle = hero.querySelector('[data-bi-hero-product]');
      const stage = hero.querySelector('.bi-hero__sticky');
      if (!bottle || !stage) return;
      heroes.set(hero, { bottle, stage, visible: false, dirty: true, last: null });
      hero.classList.toggle('has-bottle-motion', !reduced.matches);
      observer.observe(hero);
      resize?.observe(hero);
      resize?.observe(stage);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', invalidate, { passive: true });
  document.addEventListener('visibilitychange', sync);
  desktop.addEventListener('change', sync);
  reduced.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', event => { initialize(event.target); invalidate(); });
  document.addEventListener('shopify:section:reorder', invalidate);
  document.addEventListener('shopify:section:unload', event => {
    heroes.forEach((state, hero) => {
      if (!event.target.contains(hero)) return;
      observer.unobserve(hero);
      resize?.unobserve(hero); resize?.unobserve(state.stage);
      state.bottle.style.removeProperty('transform');
      hero.classList.remove('has-bottle-motion', 'bi-bottle-active');
      heroes.delete(hero);
    });
    if (frame !== null) { window.cancelAnimationFrame(frame); frame = null; }
    invalidate();
  });
})();
